import React from 'react'
import Header from '../include/Header'
// import { Link } from 'react-router-dom'
import Footer from '../include/Footer'
function ContactUs() {
    return (
        <>
            <Header />
            <div className="page-header bg-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">
                            <div className="page-header-box">
                                <h1 className="wow fadeInUp" data-cursor="-opaque">Contact Us</h1>
                                {/*  <nav className="wow fadeInUp" data-wow-delay="0.2s">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/">home</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">Contact Us</li>
                                    </ol>
                                </nav> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cta-box">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="cta-box-content">
                                <div className="section-title">
                                    <h5 className="wow fadeInUp">Merchant Legal entity name:</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        <b>Innosutra AI Private Limited</b><br /><br />
                                        <b>Address :</b> E-213, 21 Floor, ANA Avant Garde, WEH, Shivaji Chowk, Mira Road, Thane - 401107 <br /><br />
                                        <b>Telephone No:</b> 9727555057 <br /><br />
                                        <b>E-mail ID :</b> innosutraaiprivatelimited@gmail.com
                                    </p>
                                </div>
                                <div className="cta-section-shape">
                                    <img src="/assets/images/section-bg-shape-1.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default ContactUs
